import { booztLogo, booztletMobileLogo, booztletMobileLogoDe } from '@common/constants';

const deTaglineStores = ['de', 'at', 'ch'];
const hasDeTagline = store => deTaglineStores.includes(store);

export const getSlidePanelHeaderLogoName = (isBooztletEnv, store) => {
    if (isBooztletEnv && !hasDeTagline(store)) {
        return booztletMobileLogo;
    }

    if (isBooztletEnv && hasDeTagline(store)) {
        return booztletMobileLogoDe;
    }

    return booztLogo;
};
